import { State } from '@src/application/store/state';
import { reactive, watch } from 'vue';

export class Store {
    state;

    stateDefinition;

    constructor(stateDefinitions) {
        stateDefinitions = reactive(stateDefinitions);
        this.stateDefinition = stateDefinitions;
        this.state = {};
        watch(stateDefinitions, () => {
            const definedStates = Object.keys(stateDefinitions);
            const existingStates = Object.keys(this.state);
            const unusedStates = existingStates.filter((state) => !definedStates.includes(state));
            unusedStates.forEach((state) => {
                delete this.state[state];
                delete this[state];
            });

            definedStates.forEach((name) => {
                if (this.state.hasOwnProperty(name)) {
                    return;
                }
                this.state[name] = new State(name, stateDefinitions[name]);
                Object.defineProperty(this, name, {
                    get: () => {
                        return this.state[name];
                    },
                    set: () => {
                        throw new Error('set is not allowed - use the State object instead');
                    },
                });
            });
        }, { deep: true, immediate: true });
    }
}
